export const doseAmountOptions = ["1/4", "1/2", "1", "2", "3"].map((value) => ({
  label: value,
  value,
}));
